export default "__VITE_ASSET__ChVsO64g__"